import Vue from 'vue';
import axios from 'axios'
import store from '@/xreports/store/index'
import { v4 as uuidv4 } from 'uuid'
import { Message } from 'element-ui'

    import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
class BaseSurveyAPI {
  constructor(config) {
    this.config = {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1`,
      timeout: 5000000,
      withCredentials: true,
      ...config,
    }
  }

  /**
   * custome error handle function
   */
  _handleError(error) {
    // 错误统一处理
    // console.log(error)
    Message.error({
      message: '网络异常，请稍后再试',
    })
  }
  /**
   * Request API method
   * @param {String} method
   * @param {String} url
   * @param {Object} rBody
   */
  async fetch(method, body) {
    if (['/vocust-desk/menu/routes'].includes(body.url) && !store.state.systemUser.token) {
      store.dispatch('systemUser/logout')
      return
    }
    const reqId = uuidv4().replace(/-/g, '')
    const mergedHeaders = {
      Authorization: getAppBaseConfig().appId,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      reqId,
    }

    if (store.state.systemUser.token) {
      Object.assign(mergedHeaders, {
        token: store.state.systemUser.token,
      })
      if (getAppBaseConfig().loginSsoToken) {
        Object.assign(mergedHeaders, {
          ssoToken: store.state.systemUser.loginSsoToken || '',
        })
      }
    }

    return axios({
      ...this.config,
      method,
      headers: mergedHeaders,
      // include r_url, r_body
      ...body,
    })
      .then(res => {
        // HTTPCODE 始终是 200
        // 判断 code =? 200 或者 success =? true 来验证请求是否成功
        const { code, success, data, successful } = res.data
        if ((code === 200 && success === true) || (code === 'SUCCESS' && successful === true)) {
          return Promise.resolve(data)
        }
        return Promise.reject(res.data)
      })
      .catch(error => {
        console.error(`response error: url=${body.url}; reqId = ${reqId}; `)
        const data = error?.code || error?.response?.data || {}
        const { status } = error?.response || {}
        if (data.code === 401 || status === 401) {
          store.dispatch('systemUser/logout')
        } else if (status === 500) {
          requestErrorMsg()
          return Promise.reject(error)
        }
      })
  }

  async get(params) {
    return this.fetch('GET', params)
  }

  async post(body) {
    return this.fetch('POST', body)
  }
}

let showed = false
function requestErrorMsg() {
  if (showed) return
  showed = true
  Message.closeAll()
  Message.error({ message: $t('6ee78e') })
  setTimeout(() => {
    showed = false
  }, 5000)
}

export default BaseSurveyAPI
